import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Breadcrumb from "../../ProfileCommon/Breadcrumb";
import Search from "../../../../components/common/Field/Search";
import ProfileAccordion from "../../ProfileCommon/ProfileAccordion";
import { useFAQ } from "../../../../hooks/useFAQ";
import LoadingCommon from "../../../../components/common/LoadingStatus/LoadingCommon";
import { AnswerWithLink } from "../../../../Utils/helper";
import FooterContact from "../../../../components/Footer/FooterContact";

const FAQSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { section } = useParams();
  const { getFAQSection } = useFAQ();
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // Simulate loading khi component mount
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500); // 0.5s loading

    return () => clearTimeout(timer);
  }, []);

  const sectionKey = section.replace(/-([a-z])/g, (match, letter) =>
    letter.toUpperCase()
  );

  const sectionData = getFAQSection(sectionKey);

  // const filteredData = sectionData
  //   ? {
  //       ...sectionData,
  //       detail: sectionData.detail.filter((item) => {
  //         if (!searchTerm) return true;
  //         const searchLower = searchTerm.toLowerCase();
  //         return (
  //           item.question.toLowerCase().includes(searchLower) ||
  //           item.answer.toLowerCase().includes(searchLower)
  //         );
  //       }),
  //     }
  //   : null;
  const filteredData = sectionData
    ? {
        ...sectionData,
        detail: sectionData.detail.filter((item) => {
          if (!searchTerm) return true;
          const searchLower = searchTerm.toLowerCase();
          const questionMatch = item.question
            .toLowerCase()
            .includes(searchLower);

          // SỬA: Xử lý search cho answer có link
          const answerText =
            typeof item.answer === "object" ? item.answer.content : item.answer;
          const answerMatch = answerText.toLowerCase().includes(searchLower);

          return questionMatch || answerMatch;
        }),
      }
    : null;

  const handleSearchChange = (value) => {
    const searchValue =
      typeof value === "string" ? value : value?.target?.value || "";
    setSearchTerm(searchValue);
  };

  if (!sectionData && !isLoading) {
    return (
      <div className="flex flex-col w-full max-w-[480px] h-full bg-white overflow-y-auto">
          <div className="flex flex-col gap-6 flex-1 pt-[72px] px-[30px] pb-[120px]">
            <p className="text-xl text-[#333] font-medium">Section not found</p>
            <button
              onClick={() =>
                navigate("/profile/support/faq", {
                  state: { direction: -1 },
                  replace: false,
                })
              }
              className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
            >
              Back to FAQ
            </button>
          </div>
        <FooterContact className={"!bg-white"} />
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full max-w-[480px] h-full bg-white overflow-y-auto">
      <LoadingCommon statusLoading={isLoading} />
        <div className="flex flex-col gap-2 flex-1 px-[30px] pb-[120px]">
          <Breadcrumb
            breadCrumbTiltle={sectionData.title}
            onClickBack={() =>
              navigate("/profile/support/faq", {
                state: { direction: -1 },
                replace: false,
              })
            }
            classNameTitle="text-[#333333] mb-4"
          />

          <Search
            searchQuery={searchTerm}
            onSearchChange={handleSearchChange}
            placeholder={t("base.search")}
            showFavorites={false}
          />

          {filteredData.detail.length > 0 ? (
            filteredData.detail.map((item, index) => (
              <ProfileAccordion key={index} title={item.question}>
                {/* <p className="text-[16px] text-[#A0A0A0] font-medium leading-5">
                  {item.answer}
                </p> */}
                <AnswerWithLink answer={item.answer} searchTerm={searchTerm} />
              </ProfileAccordion>
            ))
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500">
                {searchTerm
                  ? `No results found for "${searchTerm}"`
                  : "No questions available"}
              </p>
            </div>
          )}
        </div>
      <FooterContact className={"!bg-white"} />
    </div>
  );
};

export default FAQSection;
